import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { TrimesterAccMentorWithAccDetails } from '@interfaces';
import { DomainDataService } from '../../../../../services';


export function getColumns(util: UtilityService, domainData: DomainDataService) {

	const columns: GridColumn<TrimesterAccMentorWithAccDetails, unknown>[] = [
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'AccName', group: 'asc' }),
		buildColumn(util, 'Id', row => row.accMentorId, { header: 'accMentorId' }),
		buildColumn(util, 'Id', row => row.accTeamId, { header: 'accTeamId' }),
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'FullName', row => row.name, { header: 'Name', renderCellClasses: row => row.dropout ? ['grid-cell-strikethrough', 'grid-cell-red-text'] : [] }),
		buildColumn(util, 'Text', row => row.location, { header: 'Location' }),
		buildColumn(util, 'Number', row => row.dropout?.dropoutWeek, { header: 'Dropout Week' }),
		buildColumn(util, 'Text', row => row.dropout?.dropoutReasonId ? domainData.data().dropoutReasonsMap[row.dropout.dropoutReasonId]?.name : undefined, { header: 'Dropout Reason' }),
	];


	return columns;

}